<div id="layout-wrapper">
    <!-- Top Bar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
    <!-- Side Bar -->
    <app-sidebar></app-sidebar>
    <ngx-loading-bar color="#27aae1" diameter="20px" [includeSpinner]="false"></ngx-loading-bar>
    <app-breadcrumb></app-breadcrumb>
    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid">

                <!-- Main Content -->
                <router-outlet></router-outlet>
            </div>
        </div>
        <!-- Footer -->
        <!-- <app-footer></app-footer> -->
    </div>
</div>